export function SupportLinks({ compact = false }: { compact?: boolean }) {
  const base = "inline-flex items-center gap-1.5 underline underline-offset-2 hover:text-ink transition-colors"
  const size = compact ? "text-xs" : "text-sm"
  return (
    <div className={`flex flex-wrap items-center gap-x-4 gap-y-1 text-ink-muted ${size}`}>
      <a 
        href="https://www.linkedin.com/in/mindful-abhay/" 
        target="_blank" 
        rel="noopener noreferrer"
        className={base}
      >
        LinkedIn — Abhay Pratap Singh
      </a>
      <span className="text-ink-light">·</span>
      <a 
        href="https://buymeacoffee.com/abhaypratapsingh" 
        target="_blank" 
        rel="noopener noreferrer"
        className={base}
      >
        Buy me a coffee
      </a>
    </div>
  )
}
